import { FormattedMessage, useIntl } from 'react-intl'
import { Grid, Toast } from 'antd-mobile-v5'
import { useHistory } from 'react-router-dom'
import React, { useCallback, useMemo, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { getCookie } from '../../components/common/cookie'
import { getEcards } from '../../reducers/selectors'
import { buildEcardImgBindItem, getEncodedId } from '../../components/common/utils'
import { localizeResource } from '../../services/utilities'
import { useBindEcard } from '../../services/hooks'
import Cert from './Cert'

import styles from './Campaign.module.css'

import { submitEcardImgBinding } from '../../actions'

const ECARD_IMG_ID = 76
const CERTS_ROUTE = '/certs'

function NewYearCampaignPage() {
  const dispatch = useDispatch()
  const [checkedCertId, setCheckedCertId] = useState()
  const { formatMessage } = useIntl()
  const { replace } = useHistory()
  const ecards = useSelector(getEcards)

  const language = getCookie('language')
  // 缓存本地化图片模块，避免在 render 中重复 require
  const images = useMemo(() => {
    const bgImg = localizeResource('tall-bg.jpg', language)
    const cardImg = localizeResource('card.jpg', language)
    return {
      bg: require(`../../assets/images/campaign/newyear/${bgImg}`),
      card: require(`../../assets/images/campaign/newyear/${cardImg}`),
      displayArea: require('../../assets/images/campaign/newyear/display-area-tall.png'),
    }
  }, [language])

  const { loading: submitLoading, run } = useBindEcard({
    onSuccess: (result, params) => {
      const firstResult = Array.isArray(result) ? result[0] : result
      const ecardId = params?.[0]?.[0]?.ecardId
      if (firstResult && ecardId) {
        dispatch(submitEcardImgBinding.success([{ ...firstResult, ecardId }]))
      }
      replace(CERTS_ROUTE)
    },
  })

  const receiveCard = useCallback(() => {
    if (submitLoading) return
    if (!checkedCertId) {
      Toast.show({
        content: formatMessage({ id: 'campaign-noEcardSelected' }),
      })
      return
    }
    run([buildEcardImgBindItem(checkedCertId, ECARD_IMG_ID)])
  }, [submitLoading, checkedCertId, formatMessage, run])

  return (
    <div className={styles['content-wrapper']}>
      <img src={images.bg} alt="new year" />
      <div className={styles['display-area-wrapper']}>
        <img src={images.displayArea} alt="title" className={styles['selected-title']} />
        <div className={styles['selected-certs-wrapper']}>
          <div className={styles.title}>
            <FormattedMessage id="newyear-card-name" />
          </div>
          <img src={images.card} alt="card" className={styles.card} />
          <div className={styles.title}>
            <FormattedMessage id="newyear-selected-cert" />
          </div>
          <div className={styles.title}>
            <FormattedMessage id="newyear-card-name" />
          </div>
          <Ecards checkedCertId={checkedCertId} onChecked={setCheckedCertId} ecards={ecards} />
          <div className={styles.btn} onClick={receiveCard}>
            <FormattedMessage id="newyear-receive-btn" />
          </div>
        </div>
      </div>
    </div>
  )
}

function Ecards({ onChecked, ecards, checkedCertId }) {
  const handleCheck = useCallback((id) => onChecked(id), [onChecked])
  return (
    <Grid columns={3} gap={8} className={styles['cert-list']}>
      {ecards.map((ecard) => (
        <Grid.Item key={ecard.uniqueId}>
          <Cert ecard={ecard} check={handleCheck} checked={checkedCertId === getEncodedId(ecard)} />
        </Grid.Item>
      ))}
    </Grid>
  )
}

export default NewYearCampaignPage
